import type { TOC } from '@ember/component/template-only'
import { array } from '@ember/helper'
import { t } from 'ember-intl'
import { not } from 'ember-truth-helpers'
import { Precinct } from 'teacher-ui-client/utils/precincts'
import { CourseProgressAverages } from 'teacher-ui-client/components/giraffe/charts/course-progress/averages'
import { CourseProgressHistory } from 'teacher-ui-client/components/giraffe/charts/course-progress/history'
import { CourseProgressTotals } from 'teacher-ui-client/components/giraffe/charts/course-progress/totals'
import { ReportingDetailedControls } from 'teacher-ui-client/components/reporting/detailed-controls'
import { ReportingNoDataMessageIf } from 'teacher-ui-client/components/reporting/no-data-message-if'
import { ReportingTeacherUiHeader } from 'teacher-ui-client/components/reporting/teacher-ui-header'
import { fullGradeName } from 'teacher-ui-client/helpers/full-grade-name'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'
import { ExportType } from 'teacher-ui-client/components/reporting/export-select'
import type { CourseProgressRexMyLessonsRoute } from 'teacher-ui-client/reporting/ui-scope/rex/course-progress/my-lessons/route'
import { CourseProgressCategories } from 'teacher-ui-client/components/tables/course-progress/categories'
import RouteTemplate from 'ember-route-template'
import { camelize } from '@ember/string'
import { concat } from '@ember/helper'

interface Signature {
  model: ModelFor<CourseProgressRexMyLessonsRoute>
}

export const RexCourseProgressMyLessons: TOC<Signature> = <template>
  <ReportingTeacherUiHeader @title={{t "reporting.pageTitles.courseProgressLessons.rex"}} />
  <ReportingDetailedControls
    @students={{@model.scopedStudents}}
    @exportOptions={{array ExportType.print}}
    @isDataPresent={{Boolean @model.myLessonsProgressAverages}}
    @showScopePicker={{true}}
    @showDatePicker={{true}}
    @studentRouteName="reporting.ui-scope.rex.student-summary"
  />
  <ReportingNoDataMessageIf @on={{not @model.myLessonsProgressAverages}}>
    {{#each @model.myLessonsProgressTotals as |gradeData|}}
      <div
        class="border-dusty-black-50 shadow-dusty-black-100 print:border-dusty-black-200 my-10 h-76 rounded-md border bg-white shadow-md print:rounded-none print:shadow-none"
      >
        <CourseProgressTotals
          @title={{t "reporting.chartTitles.courseProgressTotals"}}
          @data={{gradeData}}
          @product={{@model.product}}
          @precinct={{@model.precinct}}
          @grade={{fullGradeName gradeData.grade_position}}
          @summaryTitle={{t (concat "reporting.summaryTitles.courseProgressTotals." (camelize @model.uiScope.scope))}}
          @tooltip={{t "reporting.tooltips.courseProgressTotals"}}
        />
      </div>
    {{/each}}

    {{#if @model.myLessonsProgressCategories}}
      <div class="my-10 h-76">
        <CourseProgressCategories
          @categories={{@model.myLessonsProgressCategories}}
          @tooltip={{t "reporting.tooltips.courseProgressCategories"}}
        />
      </div>
    {{/if}}

    {{#each @model.myLessonsProgressAverages as |gradeData|}}
      <div
        class="border-dusty-black-50 shadow-dusty-black-100 print:border-dusty-black-200 my-10 h-76 rounded-md border bg-white shadow-md print:rounded-none print:shadow-none"
      >
        <CourseProgressAverages
          @data={{gradeData}}
          @precinct={{Precinct.REX_READING}}
          @title={{t (concat "reporting.chartTitles.courseProgressAverages." (camelize @model.uiScope.scope))}}
          @tooltip={{t "reporting.tooltips.courseProgressAverages"}}
        />
      </div>
    {{/each}}
    {{#if @model.myLessonsProgressHistory}}
      <CourseProgressHistory
        @tooltip={{t "reporting.tooltips.courseProgressHistory.chartInfo"}}
        @students={{@model.scopedStudents}}
        @courseProgressHistory={{@model.myLessonsProgressHistory}}
        @product={{@model.product}}
        @precinct={{@model.precinct}}
        @uiScope={{@model.uiScope.scope}}
        @studentRouteName="reporting.ui-scope.rex.student-summary"
        @themeKey={{ThemeKeys.blue}}
      />
    {{/if}}
  </ReportingNoDataMessageIf>
</template>

export default RouteTemplate(RexCourseProgressMyLessons)
